import { Route, Routes } from "react-router";
import Players from "./Players";
import AddPlayer from "./AddPlayer";
import PlayerEdit from "./PlayerEdit";

function PlayersRoutes() {
  return (
    <Routes>
      <Route path="" element={<Players />} />
      <Route path="new" element={<AddPlayer />} />
      <Route path=":player" element={<PlayerEdit />} />
    </Routes>
  );
}

export default PlayersRoutes;
